import { render, staticRenderFns } from "./wizard.vue?vue&type=template&id=c0d6fff2&scoped=true"
import script from "./wizard.vue?vue&type=script&lang=js"
export * from "./wizard.vue?vue&type=script&lang=js"
import style0 from "./wizard.vue?vue&type=style&index=0&id=c0d6fff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d6fff2",
  null
  
)

export default component.exports